import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Pagination(theme: Theme) {
  return {
    MuiPagination: {
      defaultProps: {
        color: 'primary',
      },

      styleOverrides: {
        root: {
          '& .MuiPaginationItem-root': {
            '&.Mui-selected': {
              fontWeight: theme.typography.fontWeightMedium,
            },
          },
        },
      },
    },
  }
}
